<template>
    <v-col cols="10" lg="4" class="mx-auto">
        <v-card class="pa-4">
            <div class="text-center">
                <v-avatar size="100">
                    <img :src="'./logo.png'" />
                </v-avatar>
                <h2 class="indigo--text">Logit</h2>
            </div>
            <v-form @submit.prevent="handleSubmit" ref="form">
                <v-card-text>
                    <v-text-field
                        v-model="username"
                        type="email"
                        label="Usuário"
                        placeholder="Usuário"
                        prepend-inner-icon="mdi-account"
                        required
                        autofocus
                    />
                    <v-text-field
                        v-model="password"
                        :type="passwordShow ? 'text' : 'password'"
                        label="Senha"
                        placeholder="Senha"
                        prepend-inner-icon="mdi-key"
                        :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="passwordShow = !passwordShow"
                        required
                    />
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn :loading="loading" type="submit" color="indigo">
                        <span class="white--text px-8">Logar</span>
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-col>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'Login',
    data: () => ({
        loading: false,
        passwordShow: false,
        username: '',
        password: ''
    }),
    methods: {
        ...mapActions('auth', ['login', 'me']),
        async handleSubmit() {
            if (this.$refs.form.validate()) {
                this.loading = true
                let loginError = await this.login({
                    username: this.username,
                    password: this.password
                })
                if (loginError) {
                    this.loading = false

                    let errorMessage =
                        loginError == 401
                            ? 'Usuário ou senha incorretos.'
                            : 'Ocorreu um erro. Tente novamente em alguns instantes.'

                    this.$notify({
                        message: errorMessage,
                        icon: 'add_alert',
                        horizontalAlign: 'right',
                        verticalAlign: 'bottom',
                        type: 'danger'
                    })
                }
            }
        }
    }
}
</script>
